import _ from 'lodash'
import $ from 'cash-dom'
import {fmt, s, greyscale, palette, rewind, ffwd, cancel, offset, sfc32, quadMinMax, bezierMinMax} from './util.js'

export default class Teeth{
  constructor(book){
    this.book = book
  }

  attach(dom){
    dom = $(dom).find('.diagram svg')
    let [width, height] = _.map(dom.attr('viewBox').split(' ').slice(2), _.toNumber)
    _.assign(this, {dom, width, height})

    let bars = dom.find('rect.page').map((i, elt) => ({
      x:elt.x.baseVal.value,
      y:elt.y.baseVal.value,
      width:elt.width.baseVal.value,
      height:elt.height.baseVal.value,
      depth:_.toNumber(elt.className.baseVal.match(/depth-(\d+)/)[1])
    }))

    this.depths = _.groupBy(bars, 'depth')

    return this
  }

  setDepth(depth){
    let {choices, endings, depth:maxDepth} = this.book.stats,
        pct = depth % 1,
        inv = 1 - pct,
        tendrils = []

    if (pct!=0){
      tendrils = this.depths[_.ceil(depth)].map(({x,y,width,height}) => {
        console.log(pct, {x,height:height*pct})
        let fill = greyscale(.5 + .5 * (maxDepth-(pct*depth))/maxDepth),
            stroke = greyscale(1-pct)
        return `<rect fill="${fill}" x="${x}" y="${y}" width="${width}" height="${height*pct}"/>
                <line stroke="${stroke}" stroke-width="0.25" x1="${x}" y1="${y+height}" x2="${x+width*pct}" y2="${y+height}"/>`
      })
    }


    // _.range(start, pages+1).forEach(pg => {
    //   let depth = stats.pages.depths[pg] || 0
    //   if (depth){
    //     let x = (PG_WIDTH + PG_SPACE) * (pg-1)
    //   }

    //   let ending = _.includes(stats.endings.pages, pg),
    //       clr = ending ? 'skyblue'
    //           : _.size(choices[pg]) > 1 ? palette(1 - _.min([.25*(_.size(choices[pg])-1), .8]))
    //           : illustrations[pg] ? '#aaa'
    //           : '#666'


    //   let depth = stats.pages.depths[pg] || 0,
    //       depthScale = depth * CHOICE_HEIGHT + PG_HEIGHT*1.5,
    //       depthColor = greyscale(.5 + .5 * (stats.pages.maxDepth-depth)/stats.pages.maxDepth)

    //   // elts.push(`<rect class="page depth-${depth}" fill="${clr}" x="${x}" y="${y}" width="${PG_WIDTH}" height="${PG_HEIGHT}"/>`)
    //   if (depth){
    //     elts.push(`<rect class="page depth-${depth}" fill="${depthColor}" x="${x}" y="${y+PG_HEIGHT*1.5}" width="${PG_WIDTH+PG_SPACE}" height="${depthScale-PG_HEIGHT*1.5}"/>`)
    //     elts.push(`<line class="page depth-${depth}" stroke="white" stroke-width="0.25" x1="${x}" y1="${y+depthScale}" x2="${x+PG_WIDTH+PG_SPACE}" y2="${y+depthScale}" />`)
    //   }



    //   x += PG_WIDTH + PG_SPACE
    // })










    this.dom.find('.tendrils').html(tendrils.join(' '))
  }

  get svg(){
    let PG_HEIGHT = 5,
        PG_WIDTH = 1,
        PG_SPACE = .25,
        CHOICE_HEIGHT = 1,
        ROW_HEIGHT = 4


    let {book} = this,
        {illustrations, endings, choices, pages, stats} = book

    let start = _.min(_.map(_.keys(choices), _.toNumber)),
        illos = _.countBy(_.values(illustrations)),
        // decisions = _.countBy(_.values(choices), dsts => dsts.length==1 ? 'forced' : 'choice')
        decisions = _.countBy(_.values(choices), _.size),
        maxChoices = _.max(_.map(_.values(choices), _.size))


    let width = Math.max(120, pages) * (PG_WIDTH+PG_SPACE),
        height = PG_HEIGHT*1.5 + CHOICE_HEIGHT * stats.pages.maxDepth + ROW_HEIGHT * (maxChoices+2);


    let y = 0,
        x = 0,
        h = 0,
        ct = 0,
        elts = []


    _.times(maxChoices+1, i=>{
      let gH = 2
      elts.push(`<rect fill="#111" x="0" y="${(i+1)*ROW_HEIGHT - gH/2}" width="${pages*(PG_WIDTH+PG_SPACE)}" height="${gH}"/>`)
    })


    _.range(start, pages+1).forEach(pg => {
      let depth = stats.pages.depths[pg] || 0,
          ending = _.includes(stats.endings.pages, pg),
          options = _.size(choices[pg]),
          row = ending ? maxChoices+.8 : options,
          y = row * ROW_HEIGHT

      if (ending){
        let eY = row * ROW_HEIGHT+.2,
            eX = x + PG_WIDTH/2,
            eR = .9
        elts.push(`<rect class="ending depth-${depth}" fill="skyblue" stroke-width=".4" x="${eX}" y="${eY}" width="${eR}" height="${eR}" transform="rotate(45 ${eX} ${eY})"/>`)
      }else if (options){
        let dotY = row * ROW_HEIGHT,
            dotX = x + PG_WIDTH/2,
            dotR = .45,
            fill = options==1 ? '#444': palette(1 - _.min([.25*(options-1), .8])),
            stroke = 'none'
        elts.push(`<ellipse class="ending depth-${depth}" fill="${fill}" stroke="${stroke}" stroke-width=".2" cx="${dotX}" cy="${dotY}" rx="${dotR}" ry="${dotR}" />`)
      }

      x += PG_WIDTH + PG_SPACE
    })

    x = 0
    y = maxChoices * ROW_HEIGHT

    _.range(start, pages+1).forEach(pg => {
      let ending = _.includes(stats.endings.pages, pg),
          clr = ending ? 'skyblue'
              : _.size(choices[pg]) > 1 ? palette(1 - _.min([.25*(_.size(choices[pg])-1), .8]))
              : illustrations[pg] ? '#aaa'
              : '#666'


      let depth = stats.pages.depths[pg] || 0,
          depthScale = depth * CHOICE_HEIGHT + PG_HEIGHT*1.5,
          depthColor = greyscale(.5 + .5 * (stats.pages.maxDepth-depth)/stats.pages.maxDepth)

      // elts.push(`<rect class="page depth-${depth}" fill="${clr}" x="${x}" y="${y}" width="${PG_WIDTH}" height="${PG_HEIGHT}"/>`)

      if (depth){
        elts.push(`<rect class="page depth-${depth}" fill="${depthColor}" x="${x}" y="${y+PG_HEIGHT*1.5}" width="${PG_WIDTH+PG_SPACE}" height="${depthScale-PG_HEIGHT*1.5}"/>`)
        elts.push(`<line class="page depth-${depth}" stroke="white" stroke-width="0.25" x1="${x}" y1="${y+depthScale}" x2="${x+PG_WIDTH+PG_SPACE}" y2="${y+depthScale}" />`)
      }



      x += PG_WIDTH + PG_SPACE
    })

    return `<svg class="teeth" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}">
      <g>${
      elts.join('')
      }
      <g class="tendrils"></g>
      </g>

    </svg>`
  }

}
